import { validateProfileAPI } from "@/components/dashboard/recommended/recommendedJobCard/query";

const getProfileData = async () => {
  try {
    const data = await validateProfileAPI();

    return data;
  } catch (error) {
    console.error("Failed to validate profile ", error);
  }
};

export const handleViewPreferences = async () => {
  const data = await getProfileData();

  if (!data) {
    return {
      data: null,
      handledByApp: false,
    };
  }

  const actionType = data?.actionType ? "OPEN_L1_APOP" : "OPEN_AUTOAPPLY_SHEET";

  if (typeof window.MessageHandler?.postMessage === "function") {
    window.MessageHandler.postMessage(
      JSON.stringify({
        type: actionType,
      }),
    );

    return {
      data,
      handledByApp: true,
    };
  }

  return {
    data,
    handledByApp: false,
  };
};
